import React from 'react'

import CategoryCell from './CategoryCell'

import { SORT_PARAMETERS } from '../../const/sort'
import { assetTypeColStyles } from '../../const/tableColumnsSize'

const AssetTypeCol = ({ classes, handleSortChange, selectedCategory, setSelectedCategory }) => {
  return {
    header: 'Asset Type',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: assetTypeColStyles,
    sortParameter: SORT_PARAMETERS.CATEGORY,
    onSortingChange: handleSortChange,
    Cell: productValues => {
      return (
        <CategoryCell
          productValues={productValues}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
      )
    }
  }
}

export default AssetTypeCol
